/**
 * CrispCheckout bridge for AJAX "add and checkout" buttons.
 *
 * Normal cart checkout buttons are left untouched so CrispCheckout receives
 * the shopper's real click. This helper is only used after an AJAX cart update.
 */
(function () {
  'use strict';

  var opening = false;
  var resetTimer = null;

  function usableCheckoutButton(button) {
    return Boolean(
      button &&
      button.isConnected &&
      !button.disabled &&
      button.getAttribute('aria-disabled') !== 'true'
    );
  }

  function findCheckoutButton() {
    var selectors = [
      '#CartDrawer-Checkout',
      '#checkout',
      'button[name="checkout"]',
      'input[name="checkout"]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var buttons = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < buttons.length; j += 1) {
        if (usableCheckoutButton(buttons[j])) return buttons[j];
      }
    }

    return null;
  }

  function makeTemporaryCheckoutButton() {
    var form = document.createElement('form');
    var button = document.createElement('button');

    form.action = window.routes && window.routes.cart_url
      ? window.routes.cart_url
      : '/cart';
    form.method = 'post';
    form.setAttribute('data-crisp-temporary-form', 'true');
    form.style.position = 'fixed';
    form.style.left = '-10000px';
    form.style.top = '0';
    form.style.width = '1px';
    form.style.height = '1px';
    form.style.opacity = '0';
    form.style.pointerEvents = 'none';

    button.type = 'submit';
    button.name = 'checkout';
    button.value = 'checkout';
    button.textContent = 'Check out';
    button.setAttribute('data-crisp-temporary-button', 'true');

    form.appendChild(button);
    document.body.appendChild(form);

    return button;
  }

  function removeTemporaryButton(button) {
    if (!button || button.getAttribute('data-crisp-temporary-button') !== 'true') return;
    var form = button.closest('form');
    window.setTimeout(function () {
      if (form && form.parentNode) form.parentNode.removeChild(form);
    }, 2000);
  }

  function openCrispCheckout(detail) {
    if (opening) return false;

    var button = findCheckoutButton() || makeTemporaryCheckoutButton();
    if (!button) return false;

    opening = true;
    window.clearTimeout(resetTimer);

    /*
     * Prevent only the synthetic click's native Shopify form submission.
     * The click still bubbles to CrispCheckout's document-level listener.
     */
    button.addEventListener('click', function preventNativeSyntheticCheckout(event) {
      event.preventDefault();
    }, { once: true });

    button.setAttribute('data-crisp-programmatic-checkout', 'true');

    try {
      button.click();
      document.dispatchEvent(new CustomEvent('crispcheckout:bridge-opened', {
        bubbles: true,
        detail: detail || {}
      }));
    } catch (error) {
      console.error('[CrispCheckout] Could not trigger checkout.', error);
      opening = false;
      removeTemporaryButton(button);
      return false;
    }

    removeTemporaryButton(button);

    resetTimer = window.setTimeout(function () {
      opening = false;
      button.removeAttribute('data-crisp-programmatic-checkout');
    }, 2500);

    return true;
  }

  window.CrispCheckoutBridge = window.CrispCheckoutBridge || {};
  window.CrispCheckoutBridge.open = openCrispCheckout;

  document.addEventListener('crispcheckout:open', function (event) {
    if (event.cancelable) event.preventDefault();
    openCrispCheckout(event.detail || {});
  });

  function openAfterDiscountRedirect() {
    try {
      if (window.sessionStorage.getItem('crispcheckout:open-after-discount') !== '1') return;
      window.sessionStorage.removeItem('crispcheckout:open-after-discount');
      window.setTimeout(function () {
        openCrispCheckout({ source: 'discount-form' });
      }, 250);
    } catch (error) {
      /* Storage can be blocked in private browsing. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openAfterDiscountRedirect, { once: true });
  } else {
    openAfterDiscountRedirect();
  }
})();
